import { useDispatch, useSelector } from 'react-redux';

import { Dispatch, RootState } from './store';

const useAppSelector = <T>(
    selector: (state: RootState) => T,
    equalityFn?: (left: T, right: T) => boolean,
): T => useSelector<RootState, T>(selector, equalityFn);

const useAppDispatch = () => useDispatch<Dispatch>();

export { useAppDispatch as useDispatch, useAppSelector as useSelector };
